import { withStyles } from "@mui/styles";
import { grey } from "@mui/material/colors";
import TextField from "@mui/material/TextField";
import theme from '../../constants/theme';

const SelectField = withStyles(() => ({
  root: {
    "& label.Mui-focused": {
      color: theme.palette.getContrastText(grey[500]),
      border: `1px solid  ${grey[300]}`,
      borderRadius: "20px",
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "transparent",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        color: theme.palette.getContrastText(grey[500]),
        border: `1px solid  ${grey[300]}`,
        borderRadius: "20px",
      },
      "&:hover fieldset": {
        color: theme.palette.getContrastText(grey[500]),
        border: `1px solid  ${grey[300]}`,
        borderRadius: "20px",
      },
      "&.Mui-focused fieldset": {
        color: theme.palette.getContrastText(grey[500]),
        border: `1px solid  ${grey[300]}`,
        borderRadius: "20px",
      },
    },
  },
}))(TextField);

export default SelectField;
